import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './local-storage.service';
import { ApiResponseModel } from '../models/shared-model';

@Injectable({
  providedIn: 'root'
})
export class EndCustomerService {

  ONBOARDING_BASE_URL = environment.ONBOARDING_BASE_URL;
  AUTH_BASE_URL=environment.AUTH_BASE_URL;
  userId:any;
  constructor(private http: HttpClient,private localStorageService: LocalStorageService,) {
    this.localStorageService.getUserDetails().subscribe(data=>{
      this.userId=data?.userId;
    })
   }

  executeGetRequestURL(passedurl: string, queryparams: any) : Observable<any>{
    let queryParameters = new HttpParams();
    if(queryparams){

      Object.keys(queryparams).forEach(key=>{
        if (queryparams[key] != undefined && queryparams[key] != null) {
          queryParameters = queryParameters.set(key, queryparams[key]);
        }
      })
    }
    const headers = new HttpHeaders()
      .set("Accept", "application/json")
    return this.http.get(this. ONBOARDING_BASE_URL + passedurl, { headers: headers, params: queryParameters });
  }

  getAllStaffs(role: string, roleMappingId: any, pageSize: number, pageNumber: number): Observable<any> {
    let queryParameters = new HttpParams();
  
    if (role) {
      queryParameters = queryParameters.set('role', role);
    }
  
    if (roleMappingId !== undefined && roleMappingId !== null) {
      queryParameters = queryParameters.set('roleMappingId', roleMappingId);
    }
  
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = queryParameters.set('pageSize', pageSize.toString());
    }
  
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = queryParameters.set('pageNumber', pageNumber.toString());
    }
  
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    });
  
    return this.http.request('POST', `${this.ONBOARDING_BASE_URL}/staff/all`, {
      headers,
      params: queryParameters,
      body: {}
    });
  }
  
executeGetRequestURLWithPagination(
  passedurl: string,
  queryparams: any,
  pageSize: number,
  pageNumber: number,
  keyWord: string,
  requestBody?: any 
): Observable<any> {
  let queryParameters = new HttpParams();  

  if (queryparams) {
    Object.keys(queryparams).forEach(key => {
      if (queryparams[key] !== undefined && queryparams[key] !== null) {
        queryParameters = queryParameters.set(key, queryparams[key]);
      }
    });
  }

  if (pageSize !== undefined && pageSize !== null) {
    queryParameters = queryParameters.set('pageSize', pageSize.toString());
  }

  if (pageNumber !== undefined && pageNumber !== null) {
    queryParameters = queryParameters.set('pageNumber', pageNumber.toString());
  }

  if (keyWord && keyWord.trim().length >= 2) {
    queryParameters = queryParameters.set('keyWord', keyWord);
  }

  const headers = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  });

  const body = requestBody ?? {
    roles: [],
    positionNames: [],
    status: ""
  };
  
  if (requestBody) {
    return this.http.request('POST', this.ONBOARDING_BASE_URL + passedurl, {
      headers,
      params: queryParameters,
      body
    });
  } else {
    return this.http.request('GET', this.ONBOARDING_BASE_URL + passedurl, {
      headers,
      params: queryParameters,
    });
  }
}

  public executePostRequestForAuth(url: string, body: any): Observable<any> {
    const headers = new HttpHeaders()
      .set("Accept", "application/json")
    return this.http.post(this.AUTH_BASE_URL + url, body, { headers: headers });
  }

  public executePostRequest(url: string, body: any): Observable<any> {
    const headers = new HttpHeaders()
      .set("Accept", "application/json")
      .set('userId',this.userId);
    return this.http.post(this.ONBOARDING_BASE_URL + url, body, { headers: headers });
  }

  public getAllEndCustomers(body: any, pageSize: number, pageNumber: number, searchTerm: string): Observable<any> {
    const headers = new HttpHeaders()
      .set("Accept", "application/json")
      .set('userId', this.userId);
      const params = new HttpParams()
      .set('pageSize', pageSize.toString())
      .set('pageNumber', pageNumber.toString())
      .set('searchTerm', searchTerm.toString() || '');
    return this.http.post(this.ONBOARDING_BASE_URL+"/end-customer/filter", body, { headers: headers, params: params });
}

endCustomerWithSearchKeyword(data: any, searchKeyword: any) {
  return this.http.post<ApiResponseModel<any>>(
   `${this.ONBOARDING_BASE_URL}/end-customer/summary-filters-contains?searchKeyword=${searchKeyword}`, 
    data
  );
}

checkPhoneNumber(phoneNumber: string): Observable<ApiResponseModel<string>> {
  const params = new HttpParams().set('phoneNumber', phoneNumber);
  return this.http.get<ApiResponseModel<string>>(`${this.ONBOARDING_BASE_URL}/end-customer/check-phone-number`, { params });
}

  public executePostRequestWithParam(url: string, body: any,queryparams: any): Observable<any> {
    let queryParameters = new HttpParams();
    if(queryparams){

      Object.keys(queryparams).forEach(key=>{
        if (queryparams[key] != undefined && queryparams[key] != null) {
          queryParameters = queryParameters.set(key, queryparams[key]);
        }
      })
    }

    const headers = new HttpHeaders()
      .set("Accept", "application/json")
      .set('userId',this.userId);
    return this.http.post(this.ONBOARDING_BASE_URL + url, body, { headers: headers , params: queryParameters});
  }

  public executePutRequest(url: string, body: any): Observable<any> {
    const headers = new HttpHeaders()
      .set("Accept", "application/json")
      .set('userId',this.userId);
    return this.http.put(this.ONBOARDING_BASE_URL + url, body, { headers: headers });
  }

  executeDeleteRequestURL(passedurl: string, queryparams: any) : Observable<any>{
    let queryParameters = new HttpParams();
    if(queryparams){

      Object.keys(queryparams).forEach(key=>{
        if (queryparams[key] != undefined && queryparams[key] != null) {
          queryParameters = queryParameters.set(key, queryparams[key]);
        }
      })
    }
    const headers = new HttpHeaders()
      .set("Accept", "application/json")
      .set('userId',this.userId);
    return this.http.delete(this. ONBOARDING_BASE_URL + passedurl, { headers: headers, params: queryParameters });
  }

  getEndCustomerdetails(id: string){
    return this.http.get<any>(`${this.ONBOARDING_BASE_URL}/end-customer/customerByUserId/${id}`);
  }

  hospitalsDetails(obj: any, pageSize: number, pageNumber: number){
    return this.http.post<any>(`${this.ONBOARDING_BASE_URL}/end-customer/filter?pageSize=${pageNumber}&pageNumber=${pageSize}`, obj);
  }
  doctorsDetails(obj: any, pageSize: number, pageNumber: number) {
    return this.http.post<any>(`${this.ONBOARDING_BASE_URL}/end-customer/filter?pageSize=${pageSize}&pageNumber=${pageNumber}`, obj);
  }
  labsDetails(obj: any, pageSize: number, pageNumber: number){
    return this.http.post<any>(`${this.ONBOARDING_BASE_URL}/end-customer/filter?pageSize=${pageNumber}&pageNumber=${pageSize}`, obj);
  }
  clinicsDetails(obj: any, pageSize: number, pageNumber: number){
    return this.http.post<any>(`${this.ONBOARDING_BASE_URL}/end-customer/filter?pageSize=${pageNumber}&pageNumber=${pageSize}`, obj);
  }
  getSpecialities(): Observable<any> {
    return this.http.get<any>(`${this.ONBOARDING_BASE_URL}/specialityInfo/speciality`);
  }
  getSkills(): Observable<any> {
    return this.http.get<any>(`${this.ONBOARDING_BASE_URL}/skillsetInfo/skillset`);
  }  

  hospitalDetails(id: string){
    return this.http.get<any>(`${this.ONBOARDING_BASE_URL}/end-customer/${id}`);
  }
  
  specialities(){
    return this.http.get<any>(`${this.ONBOARDING_BASE_URL}/specialityInfo/speciality`);
  }

  services(){
    return this.http.get<any>(`${this.ONBOARDING_BASE_URL}/serviceInfo/all-services`);
  }

  equipments(){
    return this.http.get<any>(`${this.ONBOARDING_BASE_URL}/equipment/all`);
  }

  public generateQRCode(data: any) : Observable<any> {
    let params = new HttpParams()
    .set('type', data?.accountType);
    return this.http.get<any>(this.AUTH_BASE_URL+`/generateQRCode/${data?.id}`,{params , responseType: 'text' as 'json'});
  }

  searchSuggestions(id :any,suggestion: string) {
    return this.http.get(`${this.ONBOARDING_BASE_URL}/end-customer/suggestions?accountType=${id}&keyWord=${suggestion}`);
   }

   public filterStaff(searchKeyword: string, filterBody: any): Observable<any> {
    const headers = new HttpHeaders()
      .set("Accept", "application/json")
      .set('userId', this.userId);
    
    let queryParams = new HttpParams();
    if (searchKeyword && searchKeyword.trim().length >= 2) {
      queryParams = queryParams.set('searchKeyword', searchKeyword);
    }
  
    return this.http.post<any>(`${this.ONBOARDING_BASE_URL}/staff/filter`, filterBody, {
      headers: headers,
      params: queryParams
    });
  }
  public checkUserRole(userId: string, roleName: string, role: string): Observable<any> {
    let params = new HttpParams()
      .set('userId', userId)
      .set('roleName', roleName)
      .set('role', role);
    return this.http.get<any>(`${this.ONBOARDING_BASE_URL}/role-type/check-user-role`, {params});
  }

  getEndCustomerCreatedBy(): Observable<ApiResponseModel<any>> {
    return this.http.get<ApiResponseModel<any>>(`${this.ONBOARDING_BASE_URL}/end-customer/createdby`);
  }

}